import { render, staticRenderFns } from "./GuidelinesDetailTenant.vue?vue&type=template&id=81f2a438&scoped=true"
import script from "./GuidelinesDetailTenant.vue?vue&type=script&lang=js"
export * from "./GuidelinesDetailTenant.vue?vue&type=script&lang=js"
import style0 from "./GuidelinesDetailTenant.vue?vue&type=style&index=0&id=81f2a438&prod&lang=css"
import style1 from "./GuidelinesDetailTenant.vue?vue&type=style&index=1&id=81f2a438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f2a438",
  null
  
)

export default component.exports